import { cronHttp } from "api/cronHttp";

const saveUdinCredentials = (data: { udin_user_id: string; password: string }) => {
  return cronHttp.post("/icaiUdin/udin/credentials", data);
};

const getUdinPortalStatus = () => {
  return cronHttp.get("/icaiUdin/udin/credentials/status");
};

const triggerUdinSync = () => {
  return cronHttp.post("/icaiUdin/udin/Sync");
};


const getUserFirms = () => {
  return cronHttp.get("/icaiUdin/udin/firms");
};

const updateFirmStatus = (firmId: number, active: string) => {
  return cronHttp.put(`/icaiUdin/udin/firms/${firmId}`, { active });
};

const getOrgUdinFilterDropDownValues = () => {
  return cronHttp.get("/icaiUdin/udin/filters");
};

const getOrgUdinStats = (years?: string[]) => {
  return cronHttp.get("/icaiUdin/udin/stats", years?.length ? { params: { years } } : undefined);
};

const getPortalUdins = (params: {
  limit: number;
  offset: number;
  search?: string;
  sort?: any;
  status?: string;
  firmIds?: number[];
  userIds?: number[];
  documentTypes?: string[];
  ayFyList?: string[];
  subTypes?: string[];
  fromDate?: string | null;
  toDate?: string | null;
  years?: string[];
}) => {
  return cronHttp.get("/icaiUdin/udin/portal-data", { params });
};

const getMonthlyChart = (years?: string[]) => {
  return cronHttp.get("/icaiUdin/udin/monthly-chart", years?.length ? { params: { years } } : undefined);
};

const getDocTypeStats = (years?: string[]) => {
  return cronHttp.get("/icaiUdin/udin/doc-type-stats", years?.length ? { params: { years } } : undefined);
};

const getTrackerStats = (years?: string[]) => {
  return cronHttp.get("/icaiUdin/udin/tracker", years?.length ? { params: { years } } : undefined);
};

const syncOrgUdins = (genYear: string | string[]) => {
  return cronHttp.post("/icaiUdin/udin/sync-org", { genYear });
};

const getSyncQueue = () => {
  return cronHttp.get("/icaiUdin/udin/sync-queue");
};

const getUdinTasks = (params: { limit: number; offset: number; search?: string }) => {
  return cronHttp.get("/icaiUdin/udin/tasks", { params });
};

const linkUdinToTask = (data: { taskId: number; udinPortalId: number }) => {
  return cronHttp.post("/icaiUdin/udin/link-task", data);
};

const unlinkUdinFromTask = (data: { taskId: number; udinPortalId: number }) => {
  return cronHttp.delete("/icaiUdin/udin/unlink-task", { data });
};

const getLinkedUdinByTask = (taskId: number) => {
  return cronHttp.get(`/icaiUdin/udin/by-task/${taskId}`);
};

const getUserUdinStatus = (userId: number) => {
  return cronHttp.get(`/icaiUdin/udin/credentials/status/user/${userId}`);
};

const saveUserUdinCredentials = (userId: number, data: { udin_user_id: string; password: string }) => {
  return cronHttp.post(`/icaiUdin/udin/credentials/user/${userId}`, data);
};

const triggerUserUdinTest = (userId: number) => {
  return cronHttp.post(`/icaiUdin/udin/login/user/${userId}`);
};

const getUserUdinFirms = (userId: number) => {
  return cronHttp.get(`/icaiUdin/udin/firms/user/${userId}`);
};

const updateUserFirmStatus = (userId: number, firmId: number, active: string) => {
  return cronHttp.put(`/icaiUdin/udin/firms/${firmId}/user/${userId}`, { active });
};

export {
  saveUdinCredentials,
  getUdinPortalStatus,
  triggerUdinSync,
  getUserFirms,
  updateFirmStatus,
  getPortalUdins,
  getOrgUdinStats,
  getOrgUdinFilterDropDownValues,
  getMonthlyChart,
  getDocTypeStats,
  getTrackerStats,
  syncOrgUdins,
  getSyncQueue,
  getUdinTasks,
  linkUdinToTask,
  unlinkUdinFromTask,
  getLinkedUdinByTask,
  getUserUdinStatus,
  saveUserUdinCredentials,
  triggerUserUdinTest,
  getUserUdinFirms,
  updateUserFirmStatus
};
